function paramStringify (json, flag) {
  let str = ''
  const keysArr = Object.keys(json)
  keysArr.sort().forEach(val => {
    if (!json[val]) return
    str += `${val}=${flag ? encodeURIComponent(json[val]) : json[val]}&`
  })
  return str.slice(0, -1)
}

function currentTime (val) {
  const date = val
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = (date.getDate()).toString()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  const dataTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  return dataTime
}

module.exports = {
  paramStringify,
  currentTime
}
